import { createPrimitiveAtom } from '@reatom/core/primitives'

export const orderIdAtom = createPrimitiveAtom<string>('')
